/* eslint-disable */
import axios from 'axios'
import {message} from 'antd'

export const voip = (mobile, callid) => {
  const digit = '9'
  const concatMobile = digit + mobile
  let phone = localStorage.getItem('internalNumber') === 'null' ? null : localStorage.getItem('internalNumber')
  if (phone && phone !== null) {
    let object = {
      phone: concatMobile,
      exten: phone,
      callid
    }
    return axios
      .get(`https://172.27.110.10:441/call/index.php`, {
        params: object,
        crossdomain: true
      })
      .then((respond) => {
        return respond
      })
      .catch((err) => {
        console.log(err)
      })
  } else {
    return Promise.reject('هیچ شماره داخلی ای برای این کاربر تعیین نشده است')
  }
}
